import type { FC } from "react";

import { Container } from "@/ui/components/layout/Container";
import { Image } from "@/ui/components/primitives/Image";
import { cn } from "@/ui/lib/utils";

import {
  OVERLAPPING_IMAGE_GROUP_DEFAULTS,
  OVERLAPPING_IMAGE_GROUP_IMAGE_CONTAINER_CLASS,
  OVERLAPPING_IMAGE_GROUP_OVERLAP_CLASS_MAP,
  OVERLAPPING_IMAGE_GROUP_SIZE_CLASS_MAP,
  type TOverlappingImageGroupProps,
} from "./OverlappingImageGroup.config";

export const OverlappingImageGroup: FC<TOverlappingImageGroupProps> = ({
  images,
  label = OVERLAPPING_IMAGE_GROUP_DEFAULTS.label,
  size = OVERLAPPING_IMAGE_GROUP_DEFAULTS.size,
  className,
  ...props
}) => (
  <Container
    {...props}
    data-component="OverlappingImageGroupItems"
    role="group"
    aria-label={label}
    className={cn("!mx-0 flex w-fit items-center", className)}
  >
    { images.map((image, index) => (
      <Container
        key={index}
        data-component="OverlappingImageGroupImage"
        style={{ zIndex: index }}
        className={cn(
          OVERLAPPING_IMAGE_GROUP_IMAGE_CONTAINER_CLASS,
          OVERLAPPING_IMAGE_GROUP_SIZE_CLASS_MAP[size],
          index > 0 ? OVERLAPPING_IMAGE_GROUP_OVERLAP_CLASS_MAP[size] : undefined,
        )}
      >
        <Image {...image} />
      </Container>
    )) }
  </Container>
);
